<template>
  <!-- pv数据 -->
  <div class="body">
    <nbqEcharts
      :xdata="['1月', '10月', '12月']"
      :ydata="[
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
        [1, 3, 5],
      ]"
    />
    <div class="footer">
    <div class="footerContent" v-for="(item, index) in footerData" :key="index">
      <div class="footerName">
        <div>
          <img src="@/assets/images/heightD.png" alt="" style="width: 58px" />
        </div>
        <div>{{ item.name }}</div>
      </div>
      <div class="footerInfo">
        <p>电压： {{ item.voltage }}</p>
        <p>电流： {{ item.current }}</p>
        <p>功率： {{ item.power }}</p>
        <p>温度： {{ item.temperature }}</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import nbqEcharts from "./nbqEcharts";
export default {
  name: "pvData",
  data() {
    return {
       footerData: [
        {
          name: "PV1",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
        {
          name: "PV2",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
        {
          name: "PV3",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
         {
          name: "PV3",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
         {
          name: "PV3",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
         {
          name: "PV3",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
         {
          name: "PV3",
          voltage: "12V",
          current: "12A",
          power: "12W",
          temperature: "12℃",
        },
      ],
    };
  },
  components: { nbqEcharts },
  methods: {},
};
</script>

<style scoped>
.body {
  padding: 16px;
  margin: 16px;
  background: white;
}
.footer {
  margin-top: 56px;
  display: flex;
  flex-wrap: wrap;
}
.footerContent {
  width: 160px;
  display: flex;
  margin-right: 150px;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;
}
.footerName {
  text-align: center;
}
</style>
